import React from 'react';
import { DraggableCard } from "../components/DraggableCard";
import { useLocalDrop } from '../basic/Utilities';

const renderCards = (cards, allowedActions, onZoom, activeCard, onToggleActiveCard, onToggleCardSide) => {
    let cardsOut = [];
    for(let i = 0; i < cards.length; i++){
        cardsOut.push(
            <DraggableCard
                id = {cards[i].id}
                isActive={activeCard === cards[i].key}
                open = {cards[i].open}
                top = {cards[i].top}
                left = {cards[i].left}
                zIndex = {cards[i].index}
                allowedActions = {allowedActions}
                itemKey = {cards[i].key}
                key = {i}
                onZoom = {onZoom}
                onToggleActive={onToggleActiveCard}
                onToggleSide={onToggleCardSide}
            />
        );
    }
    return cardsOut;
};

export const CardsTable = ({id, className, height, allowedActions, cards, onCardMove, onCardZoom, activeCard, onToggleActiveCard, onToggleCardSide}) => {
    const ref = useLocalDrop(onCardMove, id);

    return (
        <div className={className} id={id} ref={ref} style={{height}}>
            {renderCards(cards, allowedActions, onCardZoom, activeCard, onToggleActiveCard, onToggleCardSide)}
        </div>
    );
};
